/**
 * PostHog : chargement dynamique uniquement après consentement analytics.
 * Clé / hôte : variables d'environnement (recommandé) avec repli pour déploiements existants.
 */
const DEFAULT_KEY = "phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs";
const DEFAULT_HOST = "https://us.i.posthog.com";

function getKey() {
  return (process.env.REACT_APP_POSTHOG_KEY || DEFAULT_KEY).trim();
}

function getApiHost() {
  return (process.env.REACT_APP_POSTHOG_HOST || DEFAULT_HOST).replace(/\/$/, "");
}

function scriptUrl(apiHost) {
  return `${apiHost.replace(".i.posthog.com", "-assets.i.posthog.com")}/static/array.js`;
}

let loadPromise = null;

export function isPosthogLoaded() {
  return typeof window !== "undefined" && !!window.__eppPosthogLoaded;
}

export function loadPosthog() {
  if (typeof window === "undefined") return Promise.resolve();
  const key = getKey();
  if (!key) return Promise.resolve();

  if (
    document.querySelector('script[data-epp-posthog="1"]') &&
    typeof window.posthog?.opt_in_capturing === "function"
  ) {
    try {
      window.posthog.opt_in_capturing();
      window.__eppPosthogLoaded = true;
    } catch {
      /* ignore */
    }
    return Promise.resolve();
  }

  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    if (document.querySelector('script[data-epp-posthog="1"]')) {
      loadPromise = null;
      resolve();
      return;
    }
    const apiHost = getApiHost();
    const s = document.createElement("script");
    s.async = true;
    s.crossOrigin = "anonymous";
    s.dataset.eppPosthog = "1";
    s.src = scriptUrl(apiHost);
    s.onload = () => {
      try {
        if (!window.posthog?.init) {
          loadPromise = null;
          resolve();
          return;
        }
        window.posthog.init(key, {
          api_host: apiHost,
          person_profiles: "identified_only",
          session_recording: {
            recordCrossOriginIframes: true,
            capturePerformance: false,
          },
        });
        window.posthog.opt_in_capturing?.();
        window.__eppPosthogLoaded = true;
      } catch {
        loadPromise = null;
      }
      resolve();
    };
    s.onerror = () => {
      loadPromise = null;
      reject(new Error("PostHog script failed to load"));
    };
    document.body.appendChild(s);
  });

  return loadPromise;
}

export function disablePosthog() {
  if (typeof window === "undefined") return;
  try {
    window.posthog?.opt_out_capturing?.();
  } catch {
    /* ignore */
  }
  window.__eppPosthogLoaded = false;
  loadPromise = null;
}
